export default __webpack_public_path__ + "static/media/school1.3a9c7c3a.webp";